import type { ReactElement } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';

import { useAuthStore } from '@/store/auth.store';

import Login from './pages/Login';
import SsoHandoff from './pages/SsoHandoff';
import Dashboard from './pages/Dashboard';
import CurrentShiftPage from './pages/CurrentShift';
import UsersPage from './pages/Users';
import MenuPage from './pages/Menu';
import OrdersPage from './pages/Orders';
import AnalyticsPage from './pages/Analytics';
import ExpensesPage from './pages/Expenses';
import ShiftsPage from './pages/Shifts';
import ReportsPage from './pages/Reports';
import WarehousePage from './pages/Warehouse';
import DevicesPage from './pages/Devices';
import SubscriptionPage from './pages/Subscription';
import SettingsPage from './pages/Settings';
import AppCardPage from './pages/AppCard';

import { Layout } from './components/Layout';

function ProtectedRoute({ children }: { children: ReactElement }) {
  const token = useAuthStore((s) => s.accessToken);
  const location = useLocation();
  if (!token) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/sso" element={<SsoHandoff />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <Layout>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/current-shift" element={<CurrentShiftPage />} />
                <Route path="/users" element={<UsersPage />} />
                <Route path="/menu" element={<MenuPage />} />
                <Route path="/orders" element={<OrdersPage />} />
                <Route path="/analytics" element={<AnalyticsPage />} />
                <Route path="/expenses" element={<ExpensesPage />} />
                <Route path="/shifts" element={<ShiftsPage />} />
                <Route path="/reports" element={<ReportsPage />} />
                <Route path="/warehouse" element={<WarehousePage />} />
                <Route path="/devices" element={<DevicesPage />} />
                <Route path="/subscription" element={<SubscriptionPage />} />
                <Route path="/app" element={<AppCardPage />} />
                <Route path="/settings" element={<SettingsPage />} />
                <Route path="*" element={<Navigate to="/" />} />
              </Routes>
            </Layout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}
